import { Box, Divider } from "@mui/material";
import { Label } from "../../style";
import { sizes, utils } from "../../variables";
import { Container } from './style';

const TextDivider = ({ children }) => {
  return (
    <Container>
      <Divider sx={{ width: utils.width.full }}>
        <Box mx={sizes.md}>
          <Label fontFamily="Julius Sans One" fontSize={sizes.md}>
            {children}
          </Label>
        </Box>
      </Divider>
    </Container>
  );
};

export default TextDivider;
